let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lbVGU")).then(() => parcelRequire('6hKTX'));